<template>
    <div class="inOtherDetailBox">
            <div class="wrapper">
                <div class="inOtherDetail">
                    <div class="title">{{title}}</div>
                    <div class="mainbody" v-if="navArr && navArr.length>0">
            
                            <section class="firstItem" v-for="item in navArr" :key="item.id">
                                <div class="firsrTitle">
                                    <div>{{item.name}}</div>
                                </div>
                                <div class="secondTitleLine" v-if="item.son.length"></div>
                                <div class="secondTitle" v-if="item.son.length">
                                    <div class="secondTitle_item" v-for="secItem in item.son" :key="secItem.id">
                                        <div class="a">{{secItem.name}}</div>
                                        <div class="thirdTitle" v-if="secItem.son">
                                            <div class="a" v-for="thirdItem in secItem.son" :key="thirdItem.id">{{thirdItem.name}}</div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                      

                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import axios from 'axios'
import { getSort,getSiteMap } from '../../../api'
export default {
    data() {
        return {
            title:'',
            navArr:[]
        };
    },
    async created(){
       const language = this.$cookies.get('language');
       let isZhong;
        
        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        let positionInfo = {};
        if(isZhong){
            positionInfo={
                second:'网站地图',
                third:''
            }
        }else{
            positionInfo={
                second:'SITE MAP',
                third:''
            }
            
        }
        
        //获取导航树数据
        const resSiteMap = await getSiteMap();
        let navArr=resSiteMap.data;
        this.navArr  = navArr;

       
        let bannerUrl = '';
        this.title = positionInfo.second;    
        //更新bannerIn
        const res = await getSort(17);
        bannerUrl = res.data.pic;
        this.$emit('sendBanner', {bannerUrl,positionInfo});
    },
    mounted() {
        
    },
    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inOtherDetailBox {
   background: #fafdfd;  
   padding: 28px 0 66px 0;
}
.inOtherDetail {
   padding: 66px 50px 78px 50px;
   background: #fff;
  .title {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      line-height: 44px;
  }
  .mainbody {
      margin-top: 52px;
      line-height: 30px;
      display: flex;
      flex-wrap: wrap;
      .firstItem{
          width: 100%;

          &:nth-last-child(2){
              width: auto;
              margin-right: 86px;
          }
          &:last-child{
              width: auto;
          }


      }
      .firsrTitle {
        line-height: 44px;  
        margin-bottom: 18px;
            a,>div {
                font-size: 22px;
                font-weight: bold;
            }
        }
        .secondTitleLine {
            width: 100%;
            height: 1px;
            background: #b8b8b8;
        }
        .secondTitle {
            margin-top: 22px;
            display: flex;
            .secondTitle_item {
                width: 31%;
                margin-right: 2%;
                .a{
                  font-size: 18px;
                }
                .thirdTitle {
                margin-top: 22px;
                margin-bottom: 38px;
                    .a {
                        line-height: 28px;  
                        font-size: 14px;
                        display: block;
                    }
                }
            }
        }


  }
}


</style>


// WEBPACK FOOTER //
// src/pages/Other/Sitemap/Sitemap.vue